/**
 * OIDC response parameters that must never be part of a `redirect_uri`.
 *
 * When the session expires while the browser is still on a login callback URL, `location.href`
 * carries `code`, `state`, `session_state` and `iss`. Keycloak >= 26.7.3 rejects a `redirect_uri`
 * that contains any of them ("HTTP parameter pollution"), so the login must be requested with a
 * clean copy of the current URL.
 */
const FORBIDDEN_OIDC_PARAMS = [
  "code",
  "state",
  "session_state",
  "iss",
  "error",
  "error_description",
  "error_uri",
  "kc_action_status",
];

/**
 * Builds the `redirect_uri` to use for `keycloak.login()`: the current URL without the OIDC
 * response parameters (query and fragment).
 */
export function cleanLoginRedirectUri(location: Pick<Location, "href"> = window.location): string {
  const url = new URL(location.href);
  FORBIDDEN_OIDC_PARAMS.forEach(param => url.searchParams.delete(param));
  // keycloak-js uses response_mode=fragment: the callback parameters live in the hash.
  url.hash = "";
  return url.toString();
}
